export const oidcSettings = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  clientId: import.meta.env.VITE_OIDC_CLIENT_ID,
  loadUserInfo: false,
  redirectUri: `${import.meta.env.VITE_BASE_URL}/oidc/callback`,
  responseType: 'code',
  // 'groups' is required so Authelia grants the groups claim into the (opaque) access token,
  // which bahn-stats-rs reads via introspection to derive ROLE_ADMIN (admin panel gating).
  // offline_access: Authelia issues a refresh token, so oidc-client-ts can renew the (1h)
  // access token silently via the token endpoint instead of signing the user out.
  scope: 'openid profile groups offline_access',
  // Renew shortly before expiry while a tab is open; silentRedirectUri additionally gates
  // vuex-oidc's automaticSilentSignin on navigation (the refresh-token grant never actually
  // loads the iframe callback — it is only the fallback when no refresh token is present).
  automaticSilentRenew: true,
  silentRedirectUri: `${import.meta.env.VITE_BASE_URL}/oidc/silent-renew`,
}
